export default __webpack_public_path__ + "static/media/dashboard-background.7cb06422.png";